import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it suitable for department use?',
  a: 'The system provides general-purpose drafting and organizational frameworks. Review every output against your department’s SOPs, approved forms, training standards, privacy rules, and applicable requirements before official use.'
}, {
  q: 'Do I need to be a tech expert?',
  a: 'No. The prompts are designed to be copied, customized with your information, and used with compatible AI tools. You still need to review the result for accuracy and suitability.'
}, {
  q: 'Is it a one-time payment?',
  a: 'Yes. The listed price is a one-time payment of $27 for the digital materials included in this offer. No recurring subscription is intended for this product.'
}, {
  q: 'Does it replace official procedures or professional judgment?',
  a: 'No. AI-generated content is a drafting aid, not a replacement for department procedures, command decisions, qualified instruction, required inspections, emergency protocols, or applicable laws and regulations.'
}, {
  q: 'Can I enter sensitive incident or personal information into an AI tool?',
  a: 'Follow your department’s confidentiality and data-handling policies. Do not enter protected, confidential, or personally identifiable information into an AI service unless its use is expressly authorized and complies with the applicable rules.'
}, {
  q: 'Which AI tools can I use?',
  a: 'The prompts are designed for use with common AI assistants such as ChatGPT, Claude, Gemini, and DeepSeek. Availability, features, and account requirements depend on each provider.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-obsidian" data-id="element-40" data-mp="iy4m0j3gbiw9">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "25px"
    }} data-id="element-41" data-mp="mzq6oqm891h0">
        <h2 className="text-center font-display text-[28px] font-extrabold tracking-tight text-ice sm:text-4xl" data-id="element-42" data-mp="2pn55d5e9qwdv">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-43" data-mp="2ku3oirui4mrn">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className={`overflow-hidden rounded-xl border bg-charcoal transition-colors duration-200 ease-out ${isOpen ? 'border-crimson/35' : 'border-white/[0.07]'}`} data-id="element-44" data-mp="2axr0a9hq714a" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-white/[0.03] focus:outline-none focus-visible:bg-white/[0.05] sm:px-6 sm:py-5" data-id="element-45" data-mp="38j520ti6yo3s">
                  <span className="font-display text-[15px] font-bold text-ice sm:text-base" data-id="element-46" data-mp="1n86e7hq9znqs">{f.q}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${isOpen ? 'bg-crimson text-ice' : 'bg-white/[0.06] text-steel'}`} data-id="element-47" data-mp="1j6t774bg5eia">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="3us3g2ry018xv" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="2r5jrnpqttj2" />}
                  </span>
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="7nnj282b0zo0">
                  <div className="overflow-hidden" data-id="element-51" data-mp="hftb1hsk3h37">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-steel sm:px-6" data-id="element-52" data-mp="hh4j3tt1bb04">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}